export const CLASS_DATEPICKER = 'custom-datepicker';
export const ID_DATEPICKER_PORTAL = 'custom-datepicker-portal';

export const TWELVE_HOURS = 12;
